export default __webpack_public_path__ + "8b68bc2fdea027c9cd55ee03b6a7ee18.png";